import { httpsCallable } from 'firebase/functions';
import { functions } from '../lib/firebase';

export type SupportTicketCategory = 'bug' | 'account' | 'billing' | 'feature' | 'other';
export type SupportTicketPriority = 'low' | 'medium' | 'high';

export type CreateSupportTicketInput = {
  category?: SupportTicketCategory;
  priority?: SupportTicketPriority;
  subject: string;
  message: string;
  contactEmail?: string;
  userId?: string;
  userName?: string;
  deviceInfo?: string;
  appVersion?: string;
  profile?: {
    userName?: string;
    userEmail?: string;
  };
};

export type CreateSupportTicketResult = {
  ok: boolean;
  ticketId?: string;
};

const createSupportTicketCallable = httpsCallable<
  CreateSupportTicketInput,
  CreateSupportTicketResult
>(functions, 'createSupportTicket');

export const createSupportTicket = async (
  input: CreateSupportTicketInput,
): Promise<CreateSupportTicketResult> => {
  const payload: CreateSupportTicketInput = {
    category: input.category ?? 'other',
    priority: input.priority ?? 'medium',
    subject: input.subject,
    message: input.message,
    contactEmail: input.contactEmail,
    userId: input.userId,
    userName: input.userName,
    deviceInfo: input.deviceInfo,
    appVersion: input.appVersion,
    profile: {
      userName: input.profile?.userName ?? input.userName,
      userEmail: input.profile?.userEmail ?? input.contactEmail,
    },
  };

  const res = await createSupportTicketCallable(payload);
  return res.data;
};
